<div class="info-panel">
  <lx-price-lists-portal-currency [currency]="currency"></lx-price-lists-portal-currency>
  <div [ngClass]="'info-panel__panel info-panel__panel--' + company | lowercase">
    <ng-container [ngSwitch]="company">
      <lx-price-lists-portal-positively-languages-more-info
        *ngSwitchCase="companyEnum.KIL"
        [priceList]="priceList"
      ></lx-price-lists-portal-positively-languages-more-info>
      <lx-price-lists-portal-alp-more-info *ngSwitchCase="companyEnum.ALP" [priceList]="priceList"></lx-price-lists-portal-alp-more-info>
    </ng-container>
  </div>
</div>
